import Link from "next/link";
import styles from "./footer.module.scss";
import { ROUTES } from "../../../../services/router-services";

const socialMedia = [
  {
    path: "/icons/social-media/instagram.svg",
    alt: "instagram-icon",
    href: "https://www.instagram.com/digitoon.ir/"
  },
  {
    path: "/icons/social-media/whatsapp.svg",
    alt: "whatsapp-icon",
    href: "https://wa.me/+989387363982"
  },
  {
    path: "/icons/social-media/aparat.svg",
    alt: "aparat-icon",
    href: "https://www.aparat.com/digitoon"
  },
  {
    path: "/icons/social-media/soroush.svg",
    alt: "soroush-icon",
    href: "https://sapp.ir/digitoon"
  },
  {
    path: "/icons/social-media/telegram.svg",
    alt: "telegram-icon",
    href: "https://t.me/ReezeMeeze"
  }
];

const links = [
  {
    title: "دانلود اپلیکیشن دیجیتون ",
    link: ROUTES.download
  },
  {
    title: " تماس با ما ",
    link: ROUTES.contactUs
  },
  {
    title: " درباره ما ",
    link: ROUTES.aboutUs
  },
  {
    title: "سایت دیجیتون ",
    link: ROUTES.root
  }
];

interface SocialMediaProps {
  alt: string;
  path: string;
  href: string;
}

interface LinkProps {
  title: string;
  href: string;
}

function SocialMedia({ alt, path, href }: SocialMediaProps) {
  return (
    <a
      className={styles.social_media}
      target="_blank"
      href={href}
      rel="nofollow"
    >
      <img src={path} alt={alt}></img>
    </a>
  );
}

function LinkItem({ title, href }: LinkProps) {
  return (
    <Link href={href}>
      <a className={styles.link}> {title} </a>
    </Link>
  );
}

function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.w_links}>
        {links.map((link, i) => (
          <LinkItem href={link.link} title={link.title} key={"link" + i} />
        ))}
      </div>
      <hr className={styles.line} />
      <div className={styles.w_bottom_section}>
        <p className={styles.copyright}>
          تمامی حقوق متعلق به دیجیتون مگ بوده و بازنشر آن تنها با ذکر و لینک به
          منبع مجاز است.
        </p>
        <div className={styles.w_social_medias}>
          {socialMedia.map((socialMedia, i) => (
            <SocialMedia
              path={socialMedia.path}
              alt={socialMedia.alt}
              href={socialMedia.href}
              key={"socialMedia" + i}
            />
          ))}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
